import { render } from "./CategoryFilterItem.vue?vue&type=template&id=6e74b9bf"
import script from "./CategoryFilterItem.vue?vue&type=script&lang=js"
export * from "./CategoryFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__